var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisiable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_26_8",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 26 \\u2013 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_848",
    "data-name": "\\uC0AC\\uAC01\\uD615 848",
    width: 23.488,
    height: 17.15,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_847",
    "data-name": "\\uC0AC\\uAC01\\uD615 847",
    width: 26,
    height: 26,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_238",
    "data-name": "\\uADF8\\uB8F9 238",
    transform: "translate(1.256 4.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_238-2",
    "data-name": "\\uADF8\\uB8F9 238",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_593",
    "data-name": "\\uD328\\uC2A4 593",
    d: "M11.564,16.292A11.7,11.7,0,0,0,22.628,8.4,11.7,11.7,0,0,0,.5,8.4a11.7,11.7,0,0,0,11.064,7.9",
    transform: "translate(0.18 0.179)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_594",
    "data-name": "\\uD328\\uC2A4 594",
    d: "M11.744,17.152A12.381,12.381,0,0,1,.038,8.8a.666.666,0,0,1,0-.442,12.379,12.379,0,0,1,23.413,0,.683.683,0,0,1,0,.442,12.384,12.384,0,0,1-11.707,8.354M1.4,8.576a11.019,11.019,0,0,0,20.684,0,11.019,11.019,0,0,0-20.684,0",
    transform: "translate(0 0)",
    fill: "#13249f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_595",
    "data-name": "\\uD328\\uC2A4 595",
    d: "M12.54,7.124A3.087,3.087,0,1,1,9.454,4.037,3.086,3.086,0,0,1,12.54,7.124",
    transform: "translate(2.29 1.452)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_596",
    "data-name": "\\uD328\\uC2A4 596",
    d: "M9.633,11.07A3.766,3.766,0,1,1,13.4,7.3,3.771,3.771,0,0,1,9.633,11.07m0-6.173A2.407,2.407,0,1,0,12.04,7.3,2.409,2.409,0,0,0,9.633,4.9",
    transform: "translate(2.111 1.272)",
    fill: "#13249f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisiable);
export default __webpack_public_path__ + "static/media/visiable.dfb1c1896f9904efca42cf8979105a53.svg";
export { ForwardRef as ReactComponent };